import React, { useState, useEffect } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IconSun, IconMoon } from '@tabler/icons-react';

const ThemeToggle = ({ className = '', size = 20 }) => {
  const [isDark, setIsDark] = useState(false);

  // Carregar tema do localStorage na inicialização
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    const shouldBeDark = savedTheme ? savedTheme === 'dark' : prefersDark;
    
    setIsDark(shouldBeDark);
    applyTheme(shouldBeDark);
  }, []);

  // Aplicar tema ao documento
  const applyTheme = (darkMode) => {
    if (darkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  };

  // Toggle do tema
  const toggleTheme = () => {
    const newTheme = !isDark;
    setIsDark(newTheme);
    
    // Salvar no localStorage
    localStorage.setItem('theme', newTheme ? 'dark' : 'light');
    
    // Aplicar ao documento
    applyTheme(newTheme);
  };

  const tooltip = (
    <Tooltip id="theme-toggle-tooltip">
      {isDark ? 'Tema Claro' : 'Tema Escuro'}
    </Tooltip>
  );

  return (
    <OverlayTrigger placement="bottom" overlay={tooltip}>
      <button
        className={`theme-toggle-btn ${className}`}
        onClick={toggleTheme}
        type="button"
        aria-label={isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
      >
        {isDark ? (
          <IconSun size={size} className="theme-toggle-icon" />
        ) : (
          <IconMoon size={size} className="theme-toggle-icon" />
        )}
      </button>
    </OverlayTrigger>
  );
};

export default ThemeToggle;